export default {
  searchContact: 'Search a contact (3 chars min.)',
  searchError: 'An error occurred during the search',
  emptySearch: 'No contact found',
};
